import { API } from "api/API";
import axiosInstance from "api/axiosInstance";
import { TIMEOUTBACKENDCONNECTIONREQUEST } from "constants/constants";

const APIInstance = new API();

interface IBackendConnection {
    data: string;
}

export const getBackendConnection = async (): Promise<string | unknown> => {
    try {
        const url = `${APIInstance.api_root}/keepAlive`;
        const response = await axiosInstance.get<IBackendConnection>(url, {
            timeout: TIMEOUTBACKENDCONNECTIONREQUEST,
        });
        if (response.data) {
            return response.data;
        }
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};
